import Link from './link-controller'

export default Link
